import React from 'react';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { AlertIcon } from './styles';
import { shipmentEventType, warehouseEventType } from '#type';

const NotificationIcon = ({ eventId }) => {
  switch (eventId) {
    case shipmentEventType.TRIGGER_ALERT:
    case warehouseEventType.TRIGGER_APPLIANCE_GROUP_ALERT:
      return <AlertIcon />;
    default:
      return <FiberManualRecordIcon />;
  }
};

export default NotificationIcon;
